module.exports = __webpack_public_path__ + "assets/home-c7c8c57f050ab2b41756872f145df226.svg";